import Echo from "laravel-echo";
import storage from "@/core/services/storage.service";

window.Pusher = require('pusher-js');

const pusher = {
    connect() {
        Pusher.Runtime.createXHR = function () {
            const xhr = new XMLHttpRequest()
            xhr.withCredentials = true
            return xhr
        }

        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.VUE_APP_PUSHER_APP_KEY,
            wsHost: process.env.VUE_APP_PUSHER_HOST,
            encrypted: ['production', 'staging'].includes(process.env.NODE_ENV),
            forceTLS: ['production', 'staging'].includes(process.env.NODE_ENV),
            disableStats: true,
            wsPort: process.env.VUE_APP_PUSHER_PORT,
            wssPort: process.env.VUE_APP_PUSHER_PORT,
            enabledTransports: ['ws', 'wss'],
            channelAuthorization: {
                endpoint: process.env.VUE_APP_API_COMMON_URL + '/broadcasting/auth',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-XSRF-TOKEN': storage.get('XSRF-TOKEN')
                }
            },
            userAuthentication: {
                endpoint: process.env.VUE_APP_API_COMMON_URL + '/broadcasting/auth',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-XSRF-TOKEN': storage.get('XSRF-TOKEN')
                }
            },
        })
    },

    disconnect() {
        window.Echo.connector.pusher.disconnect()
    }
}

export default pusher